export default "__VITE_ASSET__CFwcxkKe__"